import { render, staticRenderFns } from "./AuthDisplay.vue?vue&type=template&id=095edc5c&"
import script from "./AuthDisplay.vue?vue&type=script&lang=ts&"
export * from "./AuthDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports